import { gql } from "graphql-request";
const GET_TWO_FA = gql`
  query get2faEnableCode {
    get2faEnableCode {
      secretToken
      otpAuthUrl
    }
  }
`;

export default GET_TWO_FA;
